//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    apiV2_7AdvantoGetStatus(cancelToken?: CancelToken | undefined): Promise<AdvantoStatusResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/advanto/get-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7AdvantoGetStatus(_response);
        });
    }

    protected processApiV2_7AdvantoGetStatus(response: AxiosResponse): Promise<AdvantoStatusResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AdvantoStatusResponseDTO.fromJS(resultData200);
            return Promise.resolve<AdvantoStatusResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoStatusResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7AdvantoSetStatus(cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/advanto/set-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7AdvantoSetStatus(_response);
        });
    }

    protected processApiV2_7AdvantoSetStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    apiV2_7Applications(body: ApplicationCreateRequestDTO, cancelToken?: CancelToken | undefined): Promise<ApplicationCreateResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7Applications(_response);
        });
    }

    protected processApiV2_7Applications(response: AxiosResponse): Promise<ApplicationCreateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApplicationCreateResponseDTO.fromJS(resultData200);
            return Promise.resolve<ApplicationCreateResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Language not exists", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("Request is not allowed for now", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Don\'t created", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationCreateResponseDTO>(null as any);
    }

    /**
     * @return Attendances
     */
    apiV2_7AttendanceGetAttendance(month: number, cancelToken?: CancelToken | undefined): Promise<GetAttendanceResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/attendance/get-attendance?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7AttendanceGetAttendance(_response);
        });
    }

    protected processApiV2_7AttendanceGetAttendance(response: AxiosResponse): Promise<GetAttendanceResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAttendanceResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAttendanceResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttendanceResponseDTO>(null as any);
    }

    /**
     * @return All Bozps
     */
    apiV2_7BozpGetAllBozp(cancelToken?: CancelToken | undefined): Promise<GetAllBozpResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/bozp/get-all-bozp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BozpGetAllBozp(_response);
        });
    }

    protected processApiV2_7BozpGetAllBozp(response: AxiosResponse): Promise<GetAllBozpResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAllBozpResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAllBozpResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllBozpResponseDTO>(null as any);
    }

    /**
     * @return User logged
     */
    apiV2_7BozpSetBozpAsRead(body: SetBozpAsReadRequestDTO, cancelToken?: CancelToken | undefined): Promise<SetBozpAsReadResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/bozp/set-bozp-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BozpSetBozpAsRead(_response);
        });
    }

    protected processApiV2_7BozpSetBozpAsRead(response: AxiosResponse): Promise<SetBozpAsReadResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SetBozpAsReadResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SetBozpAsReadResponseDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetBozpAsReadResponseDTO[]>(null as any);
    }

    /**
     * @return All buildings
     */
    apiV2_7BuildingsGetAllBuildings(cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-all-buildings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BuildingsGetAllBuildings(_response);
        });
    }

    protected processApiV2_7BuildingsGetAllBuildings(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Building
     */
    apiV2_7BuildingsGetBuildingById(buildingId: number, cancelToken?: CancelToken | undefined): Promise<BuildingResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-building-by-id?";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined and cannot be null.");
        else
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BuildingsGetBuildingById(_response);
        });
    }

    protected processApiV2_7BuildingsGetBuildingById(response: AxiosResponse): Promise<BuildingResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = BuildingResponseDTO.fromJS(resultData200);
            return Promise.resolve<BuildingResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingResponseDTO>(null as any);
    }

    /**
     * @return Employees
     */
    apiV2_7BuildingsGetEmployees(buildingId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-employees?";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined and cannot be null.");
        else
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BuildingsGetEmployees(_response);
        });
    }

    protected processApiV2_7BuildingsGetEmployees(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Images added
     */
    apiV2_7BuildingsAddImagesToBuilding(body: AddImagesRequestDTO, cancelToken?: CancelToken | undefined): Promise<AddImagesResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/add-images-to-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7BuildingsAddImagesToBuilding(_response);
        });
    }

    protected processApiV2_7BuildingsAddImagesToBuilding(response: AxiosResponse): Promise<AddImagesResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AddImagesResponseDTO.fromJS(resultData200);
            return Promise.resolve<AddImagesResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImagesResponseDTO>(null as any);
    }

    /**
     * @return All actions
     */
    apiV2_7ButtonsGetAllActions(cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buttons/get-all-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7ButtonsGetAllActions(_response);
        });
    }

    protected processApiV2_7ButtonsGetAllActions(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return All documents
     */
    apiV2_7DocumentsGetAllDocuments(cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/documents/get-all-documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7DocumentsGetAllDocuments(_response);
        });
    }

    protected processApiV2_7DocumentsGetAllDocuments(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Documents
     */
    apiV2_7DocumentsSetDocumentAsRead(body: SetDocumentAsReadRequestDTO, cancelToken?: CancelToken | undefined): Promise<DocumentResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/documents/set-document-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7DocumentsSetDocumentAsRead(_response);
        });
    }

    protected processApiV2_7DocumentsSetDocumentAsRead(response: AxiosResponse): Promise<DocumentResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentResponseDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponseDTO[]>(null as any);
    }

    /**
     * @return Documents
     */
    apiV2_7DocumentsSetDocumentAsRejected(body: SetDocumentAsRejectedRequestDTO, cancelToken?: CancelToken | undefined): Promise<DocumentResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/documents/set-document-as-rejected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7DocumentsSetDocumentAsRejected(_response);
        });
    }

    protected processApiV2_7DocumentsSetDocumentAsRejected(response: AxiosResponse): Promise<DocumentResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentResponseDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponseDTO[]>(null as any);
    }

    /**
     * @return Employee info
     */
    apiV2_7EmployeesGetInfo(cancelToken?: CancelToken | undefined): Promise<EmployeeInfoResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/employees/get-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7EmployeesGetInfo(_response);
        });
    }

    protected processApiV2_7EmployeesGetInfo(response: AxiosResponse): Promise<EmployeeInfoResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EmployeeInfoResponseDTO.fromJS(resultData200);
            return Promise.resolve<EmployeeInfoResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeInfoResponseDTO>(null as any);
    }

    /**
     * @return FCM Token updated
     */
    apiV2_7FcmToken(body: FcmTokenRequestDTO, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/fcm-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7FcmToken(_response);
        });
    }

    protected processApiV2_7FcmToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return App key info
     */
    apiV2_7IsAppKeyValid(appKey: string, cancelToken?: CancelToken | undefined): Promise<AppKeyResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/is-app-key-valid?";
        if (appKey === undefined || appKey === null)
            throw new Error("The parameter 'appKey' must be defined and cannot be null.");
        else
            url_ += "appKey=" + encodeURIComponent("" + appKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7IsAppKeyValid(_response);
        });
    }

    protected processApiV2_7IsAppKeyValid(response: AxiosResponse): Promise<AppKeyResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AppKeyResponseDTO.fromJS(resultData200);
            return Promise.resolve<AppKeyResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppKeyResponseDTO>(null as any);
    }

    /**
     * @return Language changed
     */
    apiV2_7Language(body: LanguageRequestDTO, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7Language(_response);
        });
    }

    protected processApiV2_7Language(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return User logged
     */
    apiV2_7Login(body: LoginRequestDTO, cancelToken?: CancelToken | undefined): Promise<LoginResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7Login(_response);
        });
    }

    protected processApiV2_7Login(response: AxiosResponse): Promise<LoginResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = LoginResponseDTO.fromJS(resultData200);
            return Promise.resolve<LoginResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponseDTO>(null as any);
    }

    /**
     * @return User logged
     */
    apiV2_7Logout(cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7Logout(_response);
        });
    }

    protected processApiV2_7Logout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return News
     */
    apiV2_7NewsGetAllNews(cancelToken?: CancelToken | undefined): Promise<NewsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/news/get-all-news";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7NewsGetAllNews(_response);
        });
    }

    protected processApiV2_7NewsGetAllNews(response: AxiosResponse): Promise<NewsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = NewsResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7NewsSetNewAsRead(body: NewRequestDTO, cancelToken?: CancelToken | undefined): Promise<NewSetResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/news/set-new-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7NewsSetNewAsRead(_response);
        });
    }

    protected processApiV2_7NewsSetNewAsRead(response: AxiosResponse): Promise<NewSetResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = NewSetResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewSetResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewSetResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecommendationsGetAllRecommendations(adminUserId: number, token: string, cancelToken?: CancelToken | undefined): Promise<GetAllRecommendationsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/get-all-recommendations?";
        if (adminUserId === undefined || adminUserId === null)
            throw new Error("The parameter 'adminUserId' must be defined and cannot be null.");
        else
            url_ += "adminUserId=" + encodeURIComponent("" + adminUserId) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecommendationsGetAllRecommendations(_response);
        });
    }

    protected processApiV2_7RecommendationsGetAllRecommendations(response: AxiosResponse): Promise<GetAllRecommendationsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAllRecommendationsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAllRecommendationsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRecommendationsResponseDTO>(null as any);
    }

    /**
     * @param body Pet object that needs to be added to the store
     * @return success
     */
    apiV2_7RecommendationsSendInvitations(body: SendInvitationsRequestDTO, cancelToken?: CancelToken | undefined): Promise<SendInvitationsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/send-invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecommendationsSendInvitations(_response);
        });
    }

    protected processApiV2_7RecommendationsSendInvitations(response: AxiosResponse): Promise<SendInvitationsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SendInvitationsResponseDTO.fromJS(resultData200);
            return Promise.resolve<SendInvitationsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendInvitationsResponseDTO>(null as any);
    }

    /**
     * @param body Create application from invitation
     * @return success
     */
    apiV2_7RecommendationsCreateApplicationFromInvite(body: CreateAppFromInviteRequestDTO, cancelToken?: CancelToken | undefined): Promise<ApplicationCreateResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/create-application-from-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecommendationsCreateApplicationFromInvite(_response);
        });
    }

    protected processApiV2_7RecommendationsCreateApplicationFromInvite(response: AxiosResponse): Promise<ApplicationCreateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApplicationCreateResponseDTO.fromJS(resultData200);
            return Promise.resolve<ApplicationCreateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationCreateResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecommendationsGetDataForInvite(recommendationId: number, token: string, cancelToken?: CancelToken | undefined): Promise<GetDataForInviteResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/get-data-for-invite?";
        if (recommendationId === undefined || recommendationId === null)
            throw new Error("The parameter 'recommendationId' must be defined and cannot be null.");
        else
            url_ += "recommendationId=" + encodeURIComponent("" + recommendationId) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecommendationsGetDataForInvite(_response);
        });
    }

    protected processApiV2_7RecommendationsGetDataForInvite(response: AxiosResponse): Promise<GetDataForInviteResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetDataForInviteResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetDataForInviteResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataForInviteResponseDTO>(null as any);
    }

    /**
     * @param body Sending email to Stavario about rewardsn
     * @return success
     */
    apiV2_7RecommendationsSendEmailToStavario(body: SendEmailToStavarioRequestDTO, cancelToken?: CancelToken | undefined): Promise<SendEmailToStavarioResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/send-email-to-stavario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecommendationsSendEmailToStavario(_response);
        });
    }

    protected processApiV2_7RecommendationsSendEmailToStavario(response: AxiosResponse): Promise<SendEmailToStavarioResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SendEmailToStavarioResponseDTO.fromJS(resultData200);
            return Promise.resolve<SendEmailToStavarioResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailToStavarioResponseDTO>(null as any);
    }

    /**
     * @return Record
     */
    apiV2_7RecordsGetLastRecord(cancelToken?: CancelToken | undefined): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-last-record";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsGetLastRecord(_response);
        });
    }

    protected processApiV2_7RecordsGetLastRecord(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return Record
     */
    apiV2_7RecordsGetLastRecordWithFood(cancelToken?: CancelToken | undefined): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-last-record-with-food";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsGetLastRecordWithFood(_response);
        });
    }

    protected processApiV2_7RecordsGetLastRecordWithFood(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecordsInsertRecord(body: InsertRecordRequestDTO, cancelToken?: CancelToken | undefined): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsInsertRecord(_response);
        });
    }

    protected processApiV2_7RecordsInsertRecord(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecordsInsertBreak(body: InsertBreakRequestDTO, cancelToken?: CancelToken | undefined): Promise<InsertBreakResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-break";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsInsertBreak(_response);
        });
    }

    protected processApiV2_7RecordsInsertBreak(response: AxiosResponse): Promise<InsertBreakResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = InsertBreakResponseDTO.fromJS(resultData200);
            return Promise.resolve<InsertBreakResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertBreakResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecordsInsertDoctor(body: InsertDoctorDTO, cancelToken?: CancelToken | undefined): Promise<InsertDoctorDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-doctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsInsertDoctor(_response);
        });
    }

    protected processApiV2_7RecordsInsertDoctor(response: AxiosResponse): Promise<InsertDoctorDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = InsertDoctorDTO.fromJS(resultData200);
            return Promise.resolve<InsertDoctorDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertDoctorDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecordsInsertHoliday(body: InsertHolidayDTO, cancelToken?: CancelToken | undefined): Promise<InsertHolidayDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-holiday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsInsertHoliday(_response);
        });
    }

    protected processApiV2_7RecordsInsertHoliday(response: AxiosResponse): Promise<InsertHolidayDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = InsertHolidayDTO.fromJS(resultData200);
            return Promise.resolve<InsertHolidayDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertHolidayDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RecordsInsertSick(body: InsertSickDTO, cancelToken?: CancelToken | undefined): Promise<InsertSickDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-sick";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RecordsInsertSick(_response);
        });
    }

    protected processApiV2_7RecordsInsertSick(response: AxiosResponse): Promise<InsertSickDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = InsertSickDTO.fromJS(resultData200);
            return Promise.resolve<InsertSickDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertSickDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestNewPin(body: NewPinRequestDTO, cancelToken?: CancelToken | undefined): Promise<NewPinResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/request-new-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestNewPin(_response);
        });
    }

    protected processApiV2_7RequestNewPin(response: AxiosResponse): Promise<NewPinResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = NewPinResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewPinResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewPinResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsGetRequests(state: number, limit: number, offset: number, cancelToken?: CancelToken | undefined): Promise<GetRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-requests?";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined and cannot be null.");
        else
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (limit === undefined || limit === null)
            throw new Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined and cannot be null.");
        else
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsGetRequests(_response);
        });
    }

    protected processApiV2_7RequestsGetRequests(response: AxiosResponse): Promise<GetRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetRequestsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsSetRequestState(body: UpdateRequestStateDTO, cancelToken?: CancelToken | undefined): Promise<UpdateRequestStateDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/set-request-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsSetRequestState(_response);
        });
    }

    protected processApiV2_7RequestsSetRequestState(response: AxiosResponse): Promise<UpdateRequestStateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UpdateRequestStateDTO.fromJS(resultData200);
            return Promise.resolve<UpdateRequestStateDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRequestStateDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsInsertRequest(body: InsertRequestDTO, cancelToken?: CancelToken | undefined): Promise<RequestResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/insert-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsInsertRequest(_response);
        });
    }

    protected processApiV2_7RequestsInsertRequest(response: AxiosResponse): Promise<RequestResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RequestResponseDTO.fromJS(resultData200);
            return Promise.resolve<RequestResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Database problem", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestResponseDTO>(null as any);
    }

    /**
     * @param limit (optional) 
     * @param offset (optional) 
     * @return success
     */
    apiV2_7RequestsGetMessages(requestId: number, limit: number | undefined, offset: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetMessagesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-messages?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsGetMessages(_response);
        });
    }

    protected processApiV2_7RequestsGetMessages(response: AxiosResponse): Promise<GetMessagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetMessagesDTO.fromJS(resultData200);
            return Promise.resolve<GetMessagesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMessagesDTO>(null as any);
    }

    /**
     * @param order (optional) 
     * @param limit (optional) 
     * @param from_id (optional) 
     * @return success
     */
    apiV2_7RequestsGetMessagesPaginated(requestId: number, order: Order | undefined, limit: number | undefined, from_id: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetMessagesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-messages-paginated?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (from_id === null)
            throw new Error("The parameter 'from_id' cannot be null.");
        else if (from_id !== undefined)
            url_ += "from_id=" + encodeURIComponent("" + from_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsGetMessagesPaginated(_response);
        });
    }

    protected processApiV2_7RequestsGetMessagesPaginated(response: AxiosResponse): Promise<GetMessagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetMessagesDTO.fromJS(resultData200);
            return Promise.resolve<GetMessagesDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Request not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMessagesDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsInsertMessage(body: InsertMessageRequestDTO, cancelToken?: CancelToken | undefined): Promise<InsertMessageResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/insert-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsInsertMessage(_response);
        });
    }

    protected processApiV2_7RequestsInsertMessage(response: AxiosResponse): Promise<InsertMessageResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = InsertMessageResponseDTO.fromJS(resultData200);
            return Promise.resolve<InsertMessageResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertMessageResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsSetMessagesAsRead(body: SetMessagesAsReadDTO, cancelToken?: CancelToken | undefined): Promise<SetMessagesAsReadDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/set-messages-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsSetMessagesAsRead(_response);
        });
    }

    protected processApiV2_7RequestsSetMessagesAsRead(response: AxiosResponse): Promise<SetMessagesAsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SetMessagesAsReadDTO.fromJS(resultData200);
            return Promise.resolve<SetMessagesAsReadDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetMessagesAsReadDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsGetUnreadMessagesCount(requestId: number, cancelToken?: CancelToken | undefined): Promise<CountDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-unread-messages-count?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsGetUnreadMessagesCount(_response);
        });
    }

    protected processApiV2_7RequestsGetUnreadMessagesCount(response: AxiosResponse): Promise<CountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CountDTO.fromJS(resultData200);
            return Promise.resolve<CountDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7RequestsGetAssignee(requestId: number, cancelToken?: CancelToken | undefined): Promise<AssigneeChangeResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-assignee?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7RequestsGetAssignee(_response);
        });
    }

    protected processApiV2_7RequestsGetAssignee(response: AxiosResponse): Promise<AssigneeChangeResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssigneeChangeResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssigneeChangeResponseDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssigneeChangeResponseDTO[]>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7SettingsGetSettings(cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api_v2.7/settings/get-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7SettingsGetSettings(_response);
        });
    }

    protected processApiV2_7SettingsGetSettings(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7WealthGetEmployeesWealth(cancelToken?: CancelToken | undefined): Promise<GetWealthsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/get-employees-wealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7WealthGetEmployeesWealth(_response);
        });
    }

    protected processApiV2_7WealthGetEmployeesWealth(response: AxiosResponse): Promise<GetWealthsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetWealthsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetWealthsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7WealthGetWealthByCode(wealthCode: string, cancelToken?: CancelToken | undefined): Promise<WealthDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/get-wealth-by-code?";
        if (wealthCode === undefined || wealthCode === null)
            throw new Error("The parameter 'wealthCode' must be defined and cannot be null.");
        else
            url_ += "wealthCode=" + encodeURIComponent("" + wealthCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7WealthGetWealthByCode(_response);
        });
    }

    protected processApiV2_7WealthGetWealthByCode(response: AxiosResponse): Promise<WealthDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = WealthDTO.fromJS(resultData200);
            return Promise.resolve<WealthDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WealthDTO>(null as any);
    }

    /**
     * @return success
     */
    apiV2_7WealthSetWealthToEmployee(body: WealthUpdateRequestDTO, cancelToken?: CancelToken | undefined): Promise<WealthCodesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/set-wealth-to-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiV2_7WealthSetWealthToEmployee(_response);
        });
    }

    protected processApiV2_7WealthSetWealthToEmployee(response: AxiosResponse): Promise<WealthCodesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = WealthCodesDTO.fromJS(resultData200);
            return Promise.resolve<WealthCodesDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WealthCodesDTO>(null as any);
    }

    /**
     * @return success
     */
    integrationsAdvantoEmployees(employee_id: number, national_id: string, cancelToken?: CancelToken | undefined): Promise<AdvantoEmployeeDTO> {
        let url_ = this.baseUrl + "/integrations/advanto/employees/{employee_id}?";
        if (employee_id === undefined || employee_id === null)
            throw new Error("The parameter 'employee_id' must be defined.");
        url_ = url_.replace("{employee_id}", encodeURIComponent("" + employee_id));
        if (national_id === undefined || national_id === null)
            throw new Error("The parameter 'national_id' must be defined and cannot be null.");
        else
            url_ += "national_id=" + encodeURIComponent("" + national_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrationsAdvantoEmployees(_response);
        });
    }

    protected processIntegrationsAdvantoEmployees(response: AxiosResponse): Promise<AdvantoEmployeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AdvantoEmployeeDTO.fromJS(resultData200);
            return Promise.resolve<AdvantoEmployeeDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoEmployeeDTO>(null as any);
    }

    /**
     * @return success
     */
    integrationsAdvantoShifts(employee_id: number, from: string, to: string, cancelToken?: CancelToken | undefined): Promise<AdvantoShiftsDTO[]> {
        let url_ = this.baseUrl + "/integrations/advanto/shifts/{employee_id}?";
        if (employee_id === undefined || employee_id === null)
            throw new Error("The parameter 'employee_id' must be defined.");
        url_ = url_.replace("{employee_id}", encodeURIComponent("" + employee_id));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrationsAdvantoShifts(_response);
        });
    }

    protected processIntegrationsAdvantoShifts(response: AxiosResponse): Promise<AdvantoShiftsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvantoShiftsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdvantoShiftsDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoShiftsDTO[]>(null as any);
    }
}

export class AdvantoStatusResponseDTO implements IAdvantoStatusResponseDTO {
    company?: AdvantoStatusResponseDTOCompany | undefined;
    employee?: AdvantoStatusResponseDTOEmployee | undefined;

    constructor(data?: IAdvantoStatusResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.employee = _data["employee"];
        }
    }

    static fromJS(data: any): AdvantoStatusResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoStatusResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["employee"] = this.employee;
        return data;
    }
}

export interface IAdvantoStatusResponseDTO {
    company?: AdvantoStatusResponseDTOCompany | undefined;
    employee?: AdvantoStatusResponseDTOEmployee | undefined;
}

export class ApplicationCreateRequestDTO implements IApplicationCreateRequestDTO {
    companyName!: string;
    email!: string;
    phonePrefix!: string;
    phoneNumber!: string;
    language!: string;
    source!: string;

    constructor(data?: IApplicationCreateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.phonePrefix = _data["phonePrefix"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ApplicationCreateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["phonePrefix"] = this.phonePrefix;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["source"] = this.source;
        return data;
    }
}

export interface IApplicationCreateRequestDTO {
    companyName: string;
    email: string;
    phonePrefix: string;
    phoneNumber: string;
    language: string;
    source: string;
}

export class ApplicationCreateResponseDTO implements IApplicationCreateResponseDTO {
    url?: string;
    key?: string;

    constructor(data?: IApplicationCreateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ApplicationCreateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["key"] = this.key;
        return data;
    }
}

export interface IApplicationCreateResponseDTO {
    url?: string;
    key?: string;
}

export class ActionsResponseDTO implements IActionsResponseDTO {
    type?: string;
    wage?: number;
    datetime?: string;

    constructor(data?: IActionsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.wage = _data["wage"];
            this.datetime = _data["datetime"];
        }
    }

    static fromJS(data: any): ActionsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActionsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["wage"] = this.wage;
        data["datetime"] = this.datetime;
        return data;
    }
}

export interface IActionsResponseDTO {
    type?: string;
    wage?: number;
    datetime?: string;
}

export class AttendanceResponseDTO implements IAttendanceResponseDTO {
    /** odpracovaný čas v minutách */
    minutes?: number;
    /** hodinovka */
    wage?: number;
    /** zaplaceno? */
    isPaid?: boolean;
    /** poznámka */
    note?: string;
    /** upravený záznam administrátorem? */
    isAdminEdited?: boolean;
    /** částka */
    deposit?: number;
    /** zaplaceno? */
    depositIsPaid?: string;
    /** poznámka */
    depositNote?: string;
    actions?: any;

    constructor(data?: IAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"];
            this.wage = _data["wage"];
            this.isPaid = _data["isPaid"];
            this.note = _data["note"];
            this.isAdminEdited = _data["isAdminEdited"];
            this.deposit = _data["deposit"];
            this.depositIsPaid = _data["depositIsPaid"];
            this.depositNote = _data["depositNote"];
            this.actions = _data["actions"];
        }
    }

    static fromJS(data: any): AttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes;
        data["wage"] = this.wage;
        data["isPaid"] = this.isPaid;
        data["note"] = this.note;
        data["isAdminEdited"] = this.isAdminEdited;
        data["deposit"] = this.deposit;
        data["depositIsPaid"] = this.depositIsPaid;
        data["depositNote"] = this.depositNote;
        data["actions"] = this.actions;
        return data;
    }
}

export interface IAttendanceResponseDTO {
    /** odpracovaný čas v minutách */
    minutes?: number;
    /** hodinovka */
    wage?: number;
    /** zaplaceno? */
    isPaid?: boolean;
    /** poznámka */
    note?: string;
    /** upravený záznam administrátorem? */
    isAdminEdited?: boolean;
    /** částka */
    deposit?: number;
    /** zaplaceno? */
    depositIsPaid?: string;
    /** poznámka */
    depositNote?: string;
    actions?: any;
}

export class GetAttendanceResponseDTO implements IGetAttendanceResponseDTO {
    month?: number;
    dates?: { [key: string]: AttendanceResponseDTO; };

    constructor(data?: IGetAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            if (_data["dates"]) {
                this.dates = {} as any;
                for (let key in _data["dates"]) {
                    if (_data["dates"].hasOwnProperty(key))
                        (<any>this.dates)![key] = _data["dates"][key] ? AttendanceResponseDTO.fromJS(_data["dates"][key]) : new AttendanceResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetAttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        if (this.dates) {
            data["dates"] = {};
            for (let key in this.dates) {
                if (this.dates.hasOwnProperty(key))
                    (<any>data["dates"])[key] = this.dates[key] ? this.dates[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetAttendanceResponseDTO {
    month?: number;
    dates?: { [key: string]: AttendanceResponseDTO; };
}

export class BozpItemResponseDTO implements IBozpItemResponseDTO {
    bozpId?: number;
    name?: string;
    isRead?: boolean;

    constructor(data?: IBozpItemResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bozpId = _data["bozpId"];
            this.name = _data["name"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): BozpItemResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BozpItemResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bozpId"] = this.bozpId;
        data["name"] = this.name;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IBozpItemResponseDTO {
    bozpId?: number;
    name?: string;
    isRead?: boolean;
}

export class GetAllBozpResponseDTO implements IGetAllBozpResponseDTO {
    bozp?: { [key: string]: BozpItemResponseDTO; };

    constructor(data?: IGetAllBozpResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["bozp"]) {
                this.bozp = {} as any;
                for (let key in _data["bozp"]) {
                    if (_data["bozp"].hasOwnProperty(key))
                        (<any>this.bozp)![key] = _data["bozp"][key] ? BozpItemResponseDTO.fromJS(_data["bozp"][key]) : new BozpItemResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetAllBozpResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBozpResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.bozp) {
            data["bozp"] = {};
            for (let key in this.bozp) {
                if (this.bozp.hasOwnProperty(key))
                    (<any>data["bozp"])[key] = this.bozp[key] ? this.bozp[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetAllBozpResponseDTO {
    bozp?: { [key: string]: BozpItemResponseDTO; };
}

export class SetBozpAsReadRequestDTO implements ISetBozpAsReadRequestDTO {
    bozpId!: number;
    /** obrázek podpisu (base64) */
    signature!: string;

    constructor(data?: ISetBozpAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bozpId = _data["bozpId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetBozpAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bozpId"] = this.bozpId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetBozpAsReadRequestDTO {
    bozpId: number;
    /** obrázek podpisu (base64) */
    signature: string;
}

export class SetBozpAsReadResponseDTO implements ISetBozpAsReadResponseDTO {
    bozpId?: number;
    isRead?: boolean;

    constructor(data?: ISetBozpAsReadResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bozpId = _data["bozpId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): SetBozpAsReadResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bozpId"] = this.bozpId;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ISetBozpAsReadResponseDTO {
    bozpId?: number;
    isRead?: boolean;
}

export class AddImagesRequestDTO implements IAddImagesRequestDTO {
    buildingId!: number;
    images!: string[];

    constructor(data?: IAddImagesRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): AddImagesRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IAddImagesRequestDTO {
    buildingId: number;
    images: string[];
}

export class AddImagesResponseDTO implements IAddImagesResponseDTO {
    /** Počet přidaných obrázků */
    addedImages?: number;
    images?: string;

    constructor(data?: IAddImagesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addedImages = _data["addedImages"];
            this.images = _data["images"];
        }
    }

    static fromJS(data: any): AddImagesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addedImages"] = this.addedImages;
        data["images"] = this.images;
        return data;
    }
}

export interface IAddImagesResponseDTO {
    /** Počet přidaných obrázků */
    addedImages?: number;
    images?: string;
}

export class BuildingResponseDTO implements IBuildingResponseDTO {
    buildingId?: number;
    name?: string;
    code?: string;
    city?: string;
    admin?: boolean;
    gps_point_1?: GpsPointDTO;
    gps_point_2?: GpsPointDTO | undefined;
    gps_point_3?: GpsPointDTO | undefined;
    gps_point_4?: GpsPointDTO | undefined;

    constructor(data?: IBuildingResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.city = _data["city"];
            this.admin = _data["admin"];
            this.gps_point_1 = _data["gps_point_1"] ? GpsPointDTO.fromJS(_data["gps_point_1"]) : <any>undefined;
            this.gps_point_2 = _data["gps_point_2"] ? GpsPointDTO.fromJS(_data["gps_point_2"]) : <any>undefined;
            this.gps_point_3 = _data["gps_point_3"] ? GpsPointDTO.fromJS(_data["gps_point_3"]) : <any>undefined;
            this.gps_point_4 = _data["gps_point_4"] ? GpsPointDTO.fromJS(_data["gps_point_4"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BuildingResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["city"] = this.city;
        data["admin"] = this.admin;
        data["gps_point_1"] = this.gps_point_1 ? this.gps_point_1.toJSON() : <any>undefined;
        data["gps_point_2"] = this.gps_point_2 ? this.gps_point_2.toJSON() : <any>undefined;
        data["gps_point_3"] = this.gps_point_3 ? this.gps_point_3.toJSON() : <any>undefined;
        data["gps_point_4"] = this.gps_point_4 ? this.gps_point_4.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBuildingResponseDTO {
    buildingId?: number;
    name?: string;
    code?: string;
    city?: string;
    admin?: boolean;
    gps_point_1?: GpsPointDTO;
    gps_point_2?: GpsPointDTO | undefined;
    gps_point_3?: GpsPointDTO | undefined;
    gps_point_4?: GpsPointDTO | undefined;
}

export class EmployeeDTO implements IEmployeeDTO {
    name?: string;
    code?: string;
    adminId?: number;

    constructor(data?: IEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.adminId = _data["adminId"];
        }
    }

    static fromJS(data: any): EmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["adminId"] = this.adminId;
        return data;
    }
}

export interface IEmployeeDTO {
    name?: string;
    code?: string;
    adminId?: number;
}

export class GpsPointDTO implements IGpsPointDTO {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;

    constructor(data?: IGpsPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gps_x = _data["gps_x"];
            this.gps_y = _data["gps_y"];
            this.gps_diff = _data["gps_diff"];
        }
    }

    static fromJS(data: any): GpsPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gps_x"] = this.gps_x;
        data["gps_y"] = this.gps_y;
        data["gps_diff"] = this.gps_diff;
        return data;
    }
}

export interface IGpsPointDTO {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;
}

export class ButtonResponseDTO implements IButtonResponseDTO {
    name?: string;
    type?: number;
    textColor?: string;
    backgroundColor?: string;
    disabled?: boolean;
    disabledStart?: boolean;
    disabledEnd?: boolean;

    constructor(data?: IButtonResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.textColor = _data["textColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.disabled = _data["disabled"];
            this.disabledStart = _data["disabledStart"];
            this.disabledEnd = _data["disabledEnd"];
        }
    }

    static fromJS(data: any): ButtonResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["textColor"] = this.textColor;
        data["backgroundColor"] = this.backgroundColor;
        data["disabled"] = this.disabled;
        data["disabledStart"] = this.disabledStart;
        data["disabledEnd"] = this.disabledEnd;
        return data;
    }
}

export interface IButtonResponseDTO {
    name?: string;
    type?: number;
    textColor?: string;
    backgroundColor?: string;
    disabled?: boolean;
    disabledStart?: boolean;
    disabledEnd?: boolean;
}

export class DocumentResponseDTO implements IDocumentResponseDTO {
    documentType?: DocumentResponseDTODocumentType;
    documentId?: number;
    name?: string;
    file?: string;
    isRead?: boolean;
    isRejected?: boolean;

    constructor(data?: IDocumentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
        }
    }

    static fromJS(data: any): DocumentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["name"] = this.name;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        return data;
    }
}

export interface IDocumentResponseDTO {
    documentType?: DocumentResponseDTODocumentType;
    documentId?: number;
    name?: string;
    file?: string;
    isRead?: boolean;
    isRejected?: boolean;
}

export class SetDocumentAsReadRequestDTO implements ISetDocumentAsReadRequestDTO {
    documentId!: number;
    documentType!: string;
    /** image (base64) */
    signature?: string;

    constructor(data?: ISetDocumentAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetDocumentAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetDocumentAsReadRequestDTO {
    documentId: number;
    documentType: string;
    /** image (base64) */
    signature?: string;
}

export class SetDocumentAsRejectedRequestDTO implements ISetDocumentAsRejectedRequestDTO {
    documentId!: number;
    documentType!: string;

    constructor(data?: ISetDocumentAsRejectedRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): SetDocumentAsRejectedRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsRejectedRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ISetDocumentAsRejectedRequestDTO {
    documentId: number;
    documentType: string;
}

export class ChangePinRequestDTO implements IChangePinRequestDTO {
    oldEmployeePin?: string;
    newEmployeePin?: string;

    constructor(data?: IChangePinRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldEmployeePin = _data["oldEmployeePin"];
            this.newEmployeePin = _data["newEmployeePin"];
        }
    }

    static fromJS(data: any): ChangePinRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldEmployeePin"] = this.oldEmployeePin;
        data["newEmployeePin"] = this.newEmployeePin;
        return data;
    }
}

export interface IChangePinRequestDTO {
    oldEmployeePin?: string;
    newEmployeePin?: string;
}

export class ChangePinResponseDTO implements IChangePinResponseDTO {
    changed?: boolean;

    constructor(data?: IChangePinResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): ChangePinResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changed"] = this.changed;
        return data;
    }
}

export interface IChangePinResponseDTO {
    changed?: boolean;
}

export class EmployeeInfoResponseDTO implements IEmployeeInfoResponseDTO {
    id?: number;
    adminId?: number;
    name?: string;
    code?: string;
    building_id?: number;

    constructor(data?: IEmployeeInfoResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adminId = _data["adminId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.building_id = _data["building_id"];
        }
    }

    static fromJS(data: any): EmployeeInfoResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adminId"] = this.adminId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["building_id"] = this.building_id;
        return data;
    }
}

export interface IEmployeeInfoResponseDTO {
    id?: number;
    adminId?: number;
    name?: string;
    code?: string;
    building_id?: number;
}

export class FcmTokenRequestDTO implements IFcmTokenRequestDTO {
    /** FCM Token */
    token!: string;

    constructor(data?: IFcmTokenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): FcmTokenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FcmTokenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IFcmTokenRequestDTO {
    /** FCM Token */
    token: string;
}

export class AppKeyResponseDTO implements IAppKeyResponseDTO {
    appKey?: string;
    name?: string;

    constructor(data?: IAppKeyResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appKey = _data["appKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppKeyResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppKeyResponseDTO {
    appKey?: string;
    name?: string;
}

export class LanguageRequestDTO implements ILanguageRequestDTO {
    /** Language ID (2-char) */
    language!: string;

    constructor(data?: ILanguageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LanguageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        return data;
    }
}

export interface ILanguageRequestDTO {
    /** Language ID (2-char) */
    language: string;
}

export class LoginRequestDTO implements ILoginRequestDTO {
    /** Application Key */
    appKey!: string;
    /** Employee Code */
    employeeCode!: string;
    /** Employee PIN */
    employeePin!: string;
    /** Firebase Cloud Messaging Registration ID */
    messagingToken?: string;
    /** Language ID (2-char) */
    language?: string;

    constructor(data?: ILoginRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appKey = _data["appKey"];
            this.employeeCode = _data["employeeCode"];
            this.employeePin = _data["employeePin"];
            this.messagingToken = _data["messagingToken"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LoginRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["employeeCode"] = this.employeeCode;
        data["employeePin"] = this.employeePin;
        data["messagingToken"] = this.messagingToken;
        data["language"] = this.language;
        return data;
    }
}

export interface ILoginRequestDTO {
    /** Application Key */
    appKey: string;
    /** Employee Code */
    employeeCode: string;
    /** Employee PIN */
    employeePin: string;
    /** Firebase Cloud Messaging Registration ID */
    messagingToken?: string;
    /** Language ID (2-char) */
    language?: string;
}

export class LoginResponseDTO implements ILoginResponseDTO {
    token?: string;
    token_expire?: string;

    constructor(data?: ILoginResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.token_expire = _data["token_expire"];
        }
    }

    static fromJS(data: any): LoginResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["token_expire"] = this.token_expire;
        return data;
    }
}

export interface ILoginResponseDTO {
    token?: string;
    token_expire?: string;
}

export class NewRequestDTO implements INewRequestDTO {
    newId!: number;
    signature!: string;

    constructor(data?: INewRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): NewRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface INewRequestDTO {
    newId: number;
    signature: string;
}

export class NewResponseDTO implements INewResponseDTO {
    newId?: number;
    isRead?: boolean;
    name?: string;
    file?: string;
    wealthId?: number;
    wealthDocument?: string;

    constructor(data?: INewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.isRead = _data["isRead"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.wealthId = _data["wealthId"];
            this.wealthDocument = _data["wealthDocument"];
        }
    }

    static fromJS(data: any): NewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["isRead"] = this.isRead;
        data["name"] = this.name;
        data["file"] = this.file;
        data["wealthId"] = this.wealthId;
        data["wealthDocument"] = this.wealthDocument;
        return data;
    }
}

export interface INewResponseDTO {
    newId?: number;
    isRead?: boolean;
    name?: string;
    file?: string;
    wealthId?: number;
    wealthDocument?: string;
}

export class NewSetResponseDTO implements INewSetResponseDTO {
    newId?: number;
    isRead?: boolean;

    constructor(data?: INewSetResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): NewSetResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewSetResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface INewSetResponseDTO {
    newId?: number;
    isRead?: boolean;
}

export class NewsResponseDTO implements INewsResponseDTO {
    news?: any;

    constructor(data?: INewsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"];
        }
    }

    static fromJS(data: any): NewsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news;
        return data;
    }
}

export interface INewsResponseDTO {
    news?: any;
}

export class CreateAppFromInviteRequestDTO implements ICreateAppFromInviteRequestDTO {
    companyName!: string;
    firstname?: string;
    lastname?: string;
    email!: string;
    token?: string;
    language?: string;
    phonePrefix?: string;
    phone?: string;
    recommendationId?: number;
    source?: string;

    constructor(data?: ICreateAppFromInviteRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.language = _data["language"];
            this.phonePrefix = _data["phonePrefix"];
            this.phone = _data["phone"];
            this.recommendationId = _data["recommendationId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): CreateAppFromInviteRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppFromInviteRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["token"] = this.token;
        data["language"] = this.language;
        data["phonePrefix"] = this.phonePrefix;
        data["phone"] = this.phone;
        data["recommendationId"] = this.recommendationId;
        data["source"] = this.source;
        return data;
    }
}

export interface ICreateAppFromInviteRequestDTO {
    companyName: string;
    firstname?: string;
    lastname?: string;
    email: string;
    token?: string;
    language?: string;
    phonePrefix?: string;
    phone?: string;
    recommendationId?: number;
    source?: string;
}

export class CreateAppFromInviteResponseDTO implements ICreateAppFromInviteResponseDTO {
    appId?: number;
    redirectUrl?: string;

    constructor(data?: ICreateAppFromInviteResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): CreateAppFromInviteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppFromInviteResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ICreateAppFromInviteResponseDTO {
    appId?: number;
    redirectUrl?: string;
}

export class GetAllRecommendationsRequestDTO implements IGetAllRecommendationsRequestDTO {
    adminUserId!: number;
    token!: string;

    constructor(data?: IGetAllRecommendationsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetAllRecommendationsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecommendationsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetAllRecommendationsRequestDTO {
    adminUserId: number;
    token: string;
}

export class GetAllRecommendationsResponseDTO implements IGetAllRecommendationsResponseDTO {
    invitedCount?: number;
    createdDemoCount?: number;
    paidCount?: number;
    invitedEmails?: any[];

    constructor(data?: IGetAllRecommendationsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitedCount = _data["invitedCount"];
            this.createdDemoCount = _data["createdDemoCount"];
            this.paidCount = _data["paidCount"];
            if (Array.isArray(_data["invitedEmails"])) {
                this.invitedEmails = [] as any;
                for (let item of _data["invitedEmails"])
                    this.invitedEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllRecommendationsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecommendationsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedCount"] = this.invitedCount;
        data["createdDemoCount"] = this.createdDemoCount;
        data["paidCount"] = this.paidCount;
        if (Array.isArray(this.invitedEmails)) {
            data["invitedEmails"] = [];
            for (let item of this.invitedEmails)
                data["invitedEmails"].push(item);
        }
        return data;
    }
}

export interface IGetAllRecommendationsResponseDTO {
    invitedCount?: number;
    createdDemoCount?: number;
    paidCount?: number;
    invitedEmails?: any[];
}

export class GetDataForInviteRequestDTO implements IGetDataForInviteRequestDTO {
    recommendationId!: number;
    token!: string;

    constructor(data?: IGetDataForInviteRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationId = _data["recommendationId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetDataForInviteRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForInviteRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationId"] = this.recommendationId;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetDataForInviteRequestDTO {
    recommendationId: number;
    token: string;
}

export class GetDataForInviteResponseDTO implements IGetDataForInviteResponseDTO {
    invitedPersonName?: string;
    isAppCreated?: boolean;

    constructor(data?: IGetDataForInviteResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitedPersonName = _data["invitedPersonName"];
            this.isAppCreated = _data["isAppCreated"];
        }
    }

    static fromJS(data: any): GetDataForInviteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForInviteResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedPersonName"] = this.invitedPersonName;
        data["isAppCreated"] = this.isAppCreated;
        return data;
    }
}

export interface IGetDataForInviteResponseDTO {
    invitedPersonName?: string;
    isAppCreated?: boolean;
}

export class InvitedEmailDTO implements IInvitedEmailDTO {
    email?: string;
    state?: number;

    constructor(data?: IInvitedEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): InvitedEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["state"] = this.state;
        return data;
    }
}

export interface IInvitedEmailDTO {
    email?: string;
    state?: number;
}

export class SendEmailToStavarioRequestDTO implements ISendEmailToStavarioRequestDTO {
    token!: string;
    adminUserId!: number;
    actionType!: number;

    constructor(data?: ISendEmailToStavarioRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): SendEmailToStavarioRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailToStavarioRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface ISendEmailToStavarioRequestDTO {
    token: string;
    adminUserId: number;
    actionType: number;
}

export class SendEmailToStavarioResponseDTO implements ISendEmailToStavarioResponseDTO {
    message?: string;

    constructor(data?: ISendEmailToStavarioResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendEmailToStavarioResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailToStavarioResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISendEmailToStavarioResponseDTO {
    message?: string;
}

export class SendInvitationsRequestDTO implements ISendInvitationsRequestDTO {
    adminUserId!: number;
    token!: string;
    emails?: string[];
    language?: string;

    constructor(data?: ISendInvitationsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): SendInvitationsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvitationsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["language"] = this.language;
        return data;
    }
}

export interface ISendInvitationsRequestDTO {
    adminUserId: number;
    token: string;
    emails?: string[];
    language?: string;
}

export class SendInvitationsResponseDTO implements ISendInvitationsResponseDTO {
    errors?: string[];

    constructor(data?: ISendInvitationsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): SendInvitationsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvitationsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ISendInvitationsResponseDTO {
    errors?: string[];
}

export class InsertBreakRequestDTO implements IInsertBreakRequestDTO {
    type!: string;
    gpsX!: number;
    gpsY!: number;
    accuracy?: number;
    provider?: InsertBreakRequestDTOProvider;

    constructor(data?: IInsertBreakRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.accuracy = _data["accuracy"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): InsertBreakRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["accuracy"] = this.accuracy;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IInsertBreakRequestDTO {
    type: string;
    gpsX: number;
    gpsY: number;
    accuracy?: number;
    provider?: InsertBreakRequestDTOProvider;
}

export class InsertBreakResponseDTO implements IInsertBreakResponseDTO {
    buildingId?: number;
    datetime?: string;

    constructor(data?: IInsertBreakResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.datetime = _data["datetime"];
        }
    }

    static fromJS(data: any): InsertBreakResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["datetime"] = this.datetime;
        return data;
    }
}

export interface IInsertBreakResponseDTO {
    buildingId?: number;
    datetime?: string;
}

export class InsertDoctorDTO implements IInsertDoctorDTO {
    dateDoctorFrom?: string;
    dateDoctorTo?: string;
    timeDoctorFrom?: string;
    timeDoctorTo?: string;

    constructor(data?: IInsertDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateDoctorFrom = _data["dateDoctorFrom"];
            this.dateDoctorTo = _data["dateDoctorTo"];
            this.timeDoctorFrom = _data["timeDoctorFrom"];
            this.timeDoctorTo = _data["timeDoctorTo"];
        }
    }

    static fromJS(data: any): InsertDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateDoctorFrom"] = this.dateDoctorFrom;
        data["dateDoctorTo"] = this.dateDoctorTo;
        data["timeDoctorFrom"] = this.timeDoctorFrom;
        data["timeDoctorTo"] = this.timeDoctorTo;
        return data;
    }
}

export interface IInsertDoctorDTO {
    dateDoctorFrom?: string;
    dateDoctorTo?: string;
    timeDoctorFrom?: string;
    timeDoctorTo?: string;
}

export class InsertHolidayDTO implements IInsertHolidayDTO {
    dateHolidayFrom?: string;
    dateHolidayTo?: string;
    timeHolidayFrom?: string;
    timeHolidayTo?: string;

    constructor(data?: IInsertHolidayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateHolidayFrom = _data["dateHolidayFrom"];
            this.dateHolidayTo = _data["dateHolidayTo"];
            this.timeHolidayFrom = _data["timeHolidayFrom"];
            this.timeHolidayTo = _data["timeHolidayTo"];
        }
    }

    static fromJS(data: any): InsertHolidayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateHolidayFrom"] = this.dateHolidayFrom;
        data["dateHolidayTo"] = this.dateHolidayTo;
        data["timeHolidayFrom"] = this.timeHolidayFrom;
        data["timeHolidayTo"] = this.timeHolidayTo;
        return data;
    }
}

export interface IInsertHolidayDTO {
    dateHolidayFrom?: string;
    dateHolidayTo?: string;
    timeHolidayFrom?: string;
    timeHolidayTo?: string;
}

export class InsertRecordRequestDTO implements IInsertRecordRequestDTO {
    buildingId!: number;
    gpsX?: number;
    gpsY?: number;
    accuracy?: number;
    provider?: InsertRecordRequestDTOProvider;
    /** Image (base64) */
    image!: string;
    /** EXIF informations */
    metaData!: { [key: string]: string; };
    type!: string;

    constructor(data?: IInsertRecordRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.metaData = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.accuracy = _data["accuracy"];
            this.provider = _data["provider"];
            this.image = _data["image"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InsertRecordRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRecordRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["accuracy"] = this.accuracy;
        data["provider"] = this.provider;
        data["image"] = this.image;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IInsertRecordRequestDTO {
    buildingId: number;
    gpsX?: number;
    gpsY?: number;
    accuracy?: number;
    provider?: InsertRecordRequestDTOProvider;
    /** Image (base64) */
    image: string;
    /** EXIF informations */
    metaData: { [key: string]: string; };
    type: string;
}

export class InsertSickDTO implements IInsertSickDTO {
    dateSickFrom?: string;
    dateSickTo?: string;
    timeSickFrom?: string;
    timeSickTo?: string;

    constructor(data?: IInsertSickDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateSickFrom = _data["dateSickFrom"];
            this.dateSickTo = _data["dateSickTo"];
            this.timeSickFrom = _data["timeSickFrom"];
            this.timeSickTo = _data["timeSickTo"];
        }
    }

    static fromJS(data: any): InsertSickDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSickDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateSickFrom"] = this.dateSickFrom;
        data["dateSickTo"] = this.dateSickTo;
        data["timeSickFrom"] = this.timeSickFrom;
        data["timeSickTo"] = this.timeSickTo;
        return data;
    }
}

export interface IInsertSickDTO {
    dateSickFrom?: string;
    dateSickTo?: string;
    timeSickFrom?: string;
    timeSickTo?: string;
}

export class RecordsResponseDTO implements IRecordsResponseDTO {
    action?: string;
    actionStyle?: string;
    type?: string;
    datetime?: string;
    buildingId?: number | undefined;

    constructor(data?: IRecordsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.actionStyle = _data["actionStyle"];
            this.type = _data["type"];
            this.datetime = _data["datetime"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): RecordsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["actionStyle"] = this.actionStyle;
        data["type"] = this.type;
        data["datetime"] = this.datetime;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface IRecordsResponseDTO {
    action?: string;
    actionStyle?: string;
    type?: string;
    datetime?: string;
    buildingId?: number | undefined;
}

export class NewPinRequestDTO implements INewPinRequestDTO {
    appKey!: string;
    employeeCode!: string;

    constructor(data?: INewPinRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appKey = _data["appKey"];
            this.employeeCode = _data["employeeCode"];
        }
    }

    static fromJS(data: any): NewPinRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewPinRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["employeeCode"] = this.employeeCode;
        return data;
    }
}

export interface INewPinRequestDTO {
    appKey: string;
    employeeCode: string;
}

export class NewPinResponseDTO implements INewPinResponseDTO {
    success?: boolean;

    constructor(data?: INewPinResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): NewPinResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewPinResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface INewPinResponseDTO {
    success?: boolean;
}

export class AssigneeChangeResponseDTO implements IAssigneeChangeResponseDTO {
    assignee_id?: number;
    assignee_name?: string;
    change_name?: string;
    change_time?: string;
    is_admin?: boolean;

    constructor(data?: IAssigneeChangeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignee_id = _data["assignee_id"];
            this.assignee_name = _data["assignee_name"];
            this.change_name = _data["change_name"];
            this.change_time = _data["change_time"];
            this.is_admin = _data["is_admin"];
        }
    }

    static fromJS(data: any): AssigneeChangeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeChangeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignee_id"] = this.assignee_id;
        data["assignee_name"] = this.assignee_name;
        data["change_name"] = this.change_name;
        data["change_time"] = this.change_time;
        data["is_admin"] = this.is_admin;
        return data;
    }
}

export interface IAssigneeChangeResponseDTO {
    assignee_id?: number;
    assignee_name?: string;
    change_name?: string;
    change_time?: string;
    is_admin?: boolean;
}

export class AssigneeResponseDTO implements IAssigneeResponseDTO {
    id?: number;
    name?: string;

    constructor(data?: IAssigneeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssigneeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAssigneeResponseDTO {
    id?: number;
    name?: string;
}

export class CountDTO implements ICountDTO {
    count?: number;

    constructor(data?: ICountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface ICountDTO {
    count?: number;
}

export class GetMessagesDTO implements IGetMessagesDTO {
    messages?: MessageDTO[];

    constructor(data?: IGetMessagesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessagesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessagesDTO {
    messages?: MessageDTO[];
}

export class GetRequestsResponseDTO implements IGetRequestsResponseDTO {
    requests?: RequestResponseDTO[];

    constructor(data?: IGetRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(RequestResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRequestsResponseDTO {
    requests?: RequestResponseDTO[];
}

export class InsertMessageRequestDTO implements IInsertMessageRequestDTO {
    messageImage?: string;
    messageFile?: string;
    messageFileName?: string;
    messageText!: string;
    requestId!: number;

    constructor(data?: IInsertMessageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageImage = _data["messageImage"];
            this.messageFile = _data["messageFile"];
            this.messageFileName = _data["messageFileName"];
            this.messageText = _data["messageText"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): InsertMessageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMessageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageImage"] = this.messageImage;
        data["messageFile"] = this.messageFile;
        data["messageFileName"] = this.messageFileName;
        data["messageText"] = this.messageText;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IInsertMessageRequestDTO {
    messageImage?: string;
    messageFile?: string;
    messageFileName?: string;
    messageText: string;
    requestId: number;
}

export class InsertMessageResponseDTO implements IInsertMessageResponseDTO {
    requestId!: number;
    messageFile?: string;
    messageText?: string;

    constructor(data?: IInsertMessageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.messageFile = _data["messageFile"];
            this.messageText = _data["messageText"];
        }
    }

    static fromJS(data: any): InsertMessageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMessageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["messageFile"] = this.messageFile;
        data["messageText"] = this.messageText;
        return data;
    }
}

export interface IInsertMessageResponseDTO {
    requestId: number;
    messageFile?: string;
    messageText?: string;
}

export class InsertRequestDTO implements IInsertRequestDTO {
    adminId!: number;
    buildingId?: number | undefined;
    datetimeTo?: string;
    description!: string;
    /** images (base64) */
    images?: string[];
    text!: string;
    wealthId?: number | undefined;

    constructor(data?: IInsertRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminId = _data["adminId"];
            this.buildingId = _data["buildingId"];
            this.datetimeTo = _data["datetimeTo"];
            this.description = _data["description"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.text = _data["text"];
            this.wealthId = _data["wealthId"];
        }
    }

    static fromJS(data: any): InsertRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminId"] = this.adminId;
        data["buildingId"] = this.buildingId;
        data["datetimeTo"] = this.datetimeTo;
        data["description"] = this.description;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["text"] = this.text;
        data["wealthId"] = this.wealthId;
        return data;
    }
}

export interface IInsertRequestDTO {
    adminId: number;
    buildingId?: number | undefined;
    datetimeTo?: string;
    description: string;
    /** images (base64) */
    images?: string[];
    text: string;
    wealthId?: number | undefined;
}

export class InsertRequestResponseDTO implements IInsertRequestResponseDTO {
    datetime?: string;
    datetimeTo?: string;
    buildingId?: string;
    wealthId?: string;
    text?: string;
    description?: string;

    constructor(data?: IInsertRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datetime = _data["datetime"];
            this.datetimeTo = _data["datetimeTo"];
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.text = _data["text"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InsertRequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datetime"] = this.datetime;
        data["datetimeTo"] = this.datetimeTo;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["text"] = this.text;
        data["description"] = this.description;
        return data;
    }
}

export interface IInsertRequestResponseDTO {
    datetime?: string;
    datetimeTo?: string;
    buildingId?: string;
    wealthId?: string;
    text?: string;
    description?: string;
}

export class MessageDTO implements IMessageDTO {
    id?: number;
    type?: string;
    senderName?: string;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string;
    fileUrl?: string;
    imageUrl?: string;
    datetime?: string;
    read?: boolean;

    constructor(data?: IMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderType = _data["senderType"];
            this.senderId = _data["senderId"];
            this.messageText = _data["messageText"];
            this.fileUrl = _data["fileUrl"];
            this.imageUrl = _data["imageUrl"];
            this.datetime = _data["datetime"];
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): MessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderType"] = this.senderType;
        data["senderId"] = this.senderId;
        data["messageText"] = this.messageText;
        data["fileUrl"] = this.fileUrl;
        data["imageUrl"] = this.imageUrl;
        data["datetime"] = this.datetime;
        data["read"] = this.read;
        return data;
    }
}

export interface IMessageDTO {
    id?: number;
    type?: string;
    senderName?: string;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string;
    fileUrl?: string;
    imageUrl?: string;
    datetime?: string;
    read?: boolean;
}

export class ModifyRequestRequestDTO implements IModifyRequestRequestDTO {
    requestId!: number;
    assignee_id?: number;
    duedate?: string;

    constructor(data?: IModifyRequestRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.assignee_id = _data["assignee_id"];
            this.duedate = _data["duedate"];
        }
    }

    static fromJS(data: any): ModifyRequestRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRequestRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["assignee_id"] = this.assignee_id;
        data["duedate"] = this.duedate;
        return data;
    }
}

export interface IModifyRequestRequestDTO {
    requestId: number;
    assignee_id?: number;
    duedate?: string;
}

export class ModifyRequestResponseDTO implements IModifyRequestResponseDTO {
    requestId?: number;
    assignee?: AssigneeResponseDTO;
    duedate?: string;

    constructor(data?: IModifyRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.assignee = _data["assignee"] ? AssigneeResponseDTO.fromJS(_data["assignee"]) : <any>undefined;
            this.duedate = _data["duedate"];
        }
    }

    static fromJS(data: any): ModifyRequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["duedate"] = this.duedate;
        return data;
    }
}

export interface IModifyRequestResponseDTO {
    requestId?: number;
    assignee?: AssigneeResponseDTO;
    duedate?: string;
}

export class RequestResponseDTO implements IRequestResponseDTO {
    requestId?: number;
    text?: string;
    description?: string;
    datetime?: string;
    datetimeTo?: string;
    buildingId?: number;
    wealthId?: number;
    /** State of Request
0 = NEW, 1 = OPEN, 2 = DONE */
    state?: RequestResponseDTOState;
    /** Admin name */
    adminUser?: string;
    /** Creator name */
    creator?: string;
    assignee?: AssigneeResponseDTO | undefined;
    flow?: string;
    images?: string[];
    unreadMessages?: number;

    constructor(data?: IRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.text = _data["text"];
            this.description = _data["description"];
            this.datetime = _data["datetime"];
            this.datetimeTo = _data["datetimeTo"];
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.state = _data["state"];
            this.adminUser = _data["adminUser"];
            this.creator = _data["creator"];
            this.assignee = _data["assignee"] ? AssigneeResponseDTO.fromJS(_data["assignee"]) : <any>undefined;
            this.flow = _data["flow"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.unreadMessages = _data["unreadMessages"];
        }
    }

    static fromJS(data: any): RequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["text"] = this.text;
        data["description"] = this.description;
        data["datetime"] = this.datetime;
        data["datetimeTo"] = this.datetimeTo;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["state"] = this.state;
        data["adminUser"] = this.adminUser;
        data["creator"] = this.creator;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["flow"] = this.flow;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["unreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IRequestResponseDTO {
    requestId?: number;
    text?: string;
    description?: string;
    datetime?: string;
    datetimeTo?: string;
    buildingId?: number;
    wealthId?: number;
    /** State of Request
0 = NEW, 1 = OPEN, 2 = DONE */
    state?: RequestResponseDTOState;
    /** Admin name */
    adminUser?: string;
    /** Creator name */
    creator?: string;
    assignee?: AssigneeResponseDTO | undefined;
    flow?: string;
    images?: string[];
    unreadMessages?: number;
}

export class SetMessagesAsReadDTO implements ISetMessagesAsReadDTO {
    datetime!: string;
    requestId!: number;

    constructor(data?: ISetMessagesAsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datetime = _data["datetime"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): SetMessagesAsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessagesAsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datetime"] = this.datetime;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ISetMessagesAsReadDTO {
    datetime: string;
    requestId: number;
}

export class UpdateRequestStateDTO implements IUpdateRequestStateDTO {
    requestId!: number;
    state!: number;

    constructor(data?: IUpdateRequestStateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateRequestStateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestStateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateRequestStateDTO {
    requestId: number;
    state: number;
}

export class AddWealthRequestDTO implements IAddWealthRequestDTO {
    images?: string[];

    constructor(data?: IAddWealthRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): AddWealthRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddWealthRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IAddWealthRequestDTO {
    images?: string[];
}

export class GetEmployeesLittleWealthResponseDTO implements IGetEmployeesLittleWealthResponseDTO {
    littleWealth?: { [key: string]: LittleWealthImageResponseDTO; };

    constructor(data?: IGetEmployeesLittleWealthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["littleWealth"]) {
                this.littleWealth = {} as any;
                for (let key in _data["littleWealth"]) {
                    if (_data["littleWealth"].hasOwnProperty(key))
                        (<any>this.littleWealth)![key] = _data["littleWealth"][key] ? LittleWealthImageResponseDTO.fromJS(_data["littleWealth"][key]) : new LittleWealthImageResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetEmployeesLittleWealthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesLittleWealthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.littleWealth) {
            data["littleWealth"] = {};
            for (let key in this.littleWealth) {
                if (this.littleWealth.hasOwnProperty(key))
                    (<any>data["littleWealth"])[key] = this.littleWealth[key] ? this.littleWealth[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetEmployeesLittleWealthResponseDTO {
    littleWealth?: { [key: string]: LittleWealthImageResponseDTO; };
}

export class GetWealthsResponseDTO implements IGetWealthsResponseDTO {
    wealth?: any;

    constructor(data?: IGetWealthsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealth = _data["wealth"];
        }
    }

    static fromJS(data: any): GetWealthsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealth"] = this.wealth;
        return data;
    }
}

export interface IGetWealthsResponseDTO {
    wealth?: any;
}

export class LittleWealthImageResponseDTO implements ILittleWealthImageResponseDTO {
    image?: string;
    file?: string;
    isRead?: boolean;

    constructor(data?: ILittleWealthImageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): LittleWealthImageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LittleWealthImageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ILittleWealthImageResponseDTO {
    image?: string;
    file?: string;
    isRead?: boolean;
}

export class LittleWealthResponseDTO implements ILittleWealthResponseDTO {
    littleWealth?: { [key: string]: string; }[];

    constructor(data?: ILittleWealthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["littleWealth"])) {
                this.littleWealth = [] as any;
                for (let item of _data["littleWealth"])
                    this.littleWealth!.push(item);
            }
        }
    }

    static fromJS(data: any): LittleWealthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LittleWealthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.littleWealth)) {
            data["littleWealth"] = [];
            for (let item of this.littleWealth)
                data["littleWealth"].push(item);
        }
        return data;
    }
}

export interface ILittleWealthResponseDTO {
    littleWealth?: { [key: string]: string; }[];
}

export class SetLittleWealthAsReadRequestDTO implements ISetLittleWealthAsReadRequestDTO {
    littleWealthFileName?: string;
    signature?: string;

    constructor(data?: ISetLittleWealthAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.littleWealthFileName = _data["littleWealthFileName"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetLittleWealthAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetLittleWealthAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["littleWealthFileName"] = this.littleWealthFileName;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetLittleWealthAsReadRequestDTO {
    littleWealthFileName?: string;
    signature?: string;
}

export class SetLittleWealthAsReadResponseDTO implements ISetLittleWealthAsReadResponseDTO {
    littleWealthFileName?: string;
    isRead?: boolean;

    constructor(data?: ISetLittleWealthAsReadResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.littleWealthFileName = _data["littleWealthFileName"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): SetLittleWealthAsReadResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetLittleWealthAsReadResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["littleWealthFileName"] = this.littleWealthFileName;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ISetLittleWealthAsReadResponseDTO {
    littleWealthFileName?: string;
    isRead?: boolean;
}

export class WealthCodesDTO implements IWealthCodesDTO {
    codes?: string[];

    constructor(data?: IWealthCodesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(item);
            }
        }
    }

    static fromJS(data: any): WealthCodesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthCodesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        return data;
    }
}

export interface IWealthCodesDTO {
    codes?: string[];
}

export class WealthDTO implements IWealthDTO {
    wealthId?: number;
    name?: string;
    code?: string;
    serialNumber?: string;
    previewImage?: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    constructor(data?: IWealthDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealthId = _data["wealthId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.previewImage = _data["previewImage"];
            this.rentDateOrientationFrom = _data["rentDateOrientationFrom"];
            this.rentDateOrientationTo = _data["rentDateOrientationTo"];
        }
    }

    static fromJS(data: any): WealthDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealthId"] = this.wealthId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["previewImage"] = this.previewImage;
        data["rentDateOrientationFrom"] = this.rentDateOrientationFrom;
        data["rentDateOrientationTo"] = this.rentDateOrientationTo;
        return data;
    }
}

export interface IWealthDTO {
    wealthId?: number;
    name?: string;
    code?: string;
    serialNumber?: string;
    previewImage?: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;
}

export class WealthUpdateRequestDTO implements IWealthUpdateRequestDTO {
    buildingId?: number | undefined;
    stockWarehouseId?: number | undefined;
    wealthCodes!: number[];
    signature!: string;
    image!: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    constructor(data?: IWealthUpdateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wealthCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.stockWarehouseId = _data["stockWarehouseId"];
            if (Array.isArray(_data["wealthCodes"])) {
                this.wealthCodes = [] as any;
                for (let item of _data["wealthCodes"])
                    this.wealthCodes!.push(item);
            }
            this.signature = _data["signature"];
            this.image = _data["image"];
            this.rentDateOrientationFrom = _data["rentDateOrientationFrom"];
            this.rentDateOrientationTo = _data["rentDateOrientationTo"];
        }
    }

    static fromJS(data: any): WealthUpdateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthUpdateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["stockWarehouseId"] = this.stockWarehouseId;
        if (Array.isArray(this.wealthCodes)) {
            data["wealthCodes"] = [];
            for (let item of this.wealthCodes)
                data["wealthCodes"].push(item);
        }
        data["signature"] = this.signature;
        data["image"] = this.image;
        data["rentDateOrientationFrom"] = this.rentDateOrientationFrom;
        data["rentDateOrientationTo"] = this.rentDateOrientationTo;
        return data;
    }
}

export interface IWealthUpdateRequestDTO {
    buildingId?: number | undefined;
    stockWarehouseId?: number | undefined;
    wealthCodes: number[];
    signature: string;
    image: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;
}

export class AdvantoEmployeeDTO implements IAdvantoEmployeeDTO {
    id?: number;
    firstname?: string;
    lastname?: string;
    national_id?: string;
    bank_account_number?: string;
    email?: string;
    phone_number?: string;
    hourly_wage?: number;
    address_street?: string;
    address_city?: string;
    address_country?: string;
    address_zip?: string;

    constructor(data?: IAdvantoEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.national_id = _data["national_id"];
            this.bank_account_number = _data["bank_account_number"];
            this.email = _data["email"];
            this.phone_number = _data["phone_number"];
            this.hourly_wage = _data["hourly_wage"];
            this.address_street = _data["address_street"];
            this.address_city = _data["address_city"];
            this.address_country = _data["address_country"];
            this.address_zip = _data["address_zip"];
        }
    }

    static fromJS(data: any): AdvantoEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["national_id"] = this.national_id;
        data["bank_account_number"] = this.bank_account_number;
        data["email"] = this.email;
        data["phone_number"] = this.phone_number;
        data["hourly_wage"] = this.hourly_wage;
        data["address_street"] = this.address_street;
        data["address_city"] = this.address_city;
        data["address_country"] = this.address_country;
        data["address_zip"] = this.address_zip;
        return data;
    }
}

export interface IAdvantoEmployeeDTO {
    id?: number;
    firstname?: string;
    lastname?: string;
    national_id?: string;
    bank_account_number?: string;
    email?: string;
    phone_number?: string;
    hourly_wage?: number;
    address_street?: string;
    address_city?: string;
    address_country?: string;
    address_zip?: string;
}

export class AdvantoShiftsDTO implements IAdvantoShiftsDTO {
    id?: number;
    date?: any;
    hours?: number;
    wage?: number;

    constructor(data?: IAdvantoShiftsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.hours = _data["hours"];
            this.wage = _data["wage"];
        }
    }

    static fromJS(data: any): AdvantoShiftsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoShiftsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["hours"] = this.hours;
        data["wage"] = this.wage;
        return data;
    }
}

export interface IAdvantoShiftsDTO {
    id?: number;
    date?: any;
    hours?: number;
    wage?: number;
}

export enum Order {
    N = "N",
    O = "O",
}

export enum AdvantoStatusResponseDTOCompany {
    Waiting = "waiting",
    Available = "available",
}

export enum AdvantoStatusResponseDTOEmployee {
    Waiting = "waiting",
    Available = "available",
}

export enum DocumentResponseDTODocumentType {
    Document = "document",
    DocumentTemplate = "documentTemplate",
}

export enum InsertBreakRequestDTOProvider {
    Fused = "fused",
    Gps = "gps",
    Network = "network",
    Passive = "passive",
}

export enum InsertRecordRequestDTOProvider {
    Fused = "fused",
    Gps = "gps",
    Network = "network",
    Passive = "passive",
}

export enum MessageDTOSenderType {
    Admin = "admin",
    Investor = "investor",
    Employee = "employee",
}

export enum RequestResponseDTOState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}